<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="form-group">
            <label for="equipment">Equipment</label>
            <wj-combo-box
                id="equipment"
                name="equipment"
                [(ngModel)]="target.equipment"
                [itemsSource]="equipmentOptions"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                required
            ></wj-combo-box>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="mainEdgePartNumber">GET main edge or teeth part #</label>
                    <input id="mainEdgePartNumber" type="text" class="form-control" [(ngModel)]="target.mainEdgePartNumber" name="mainEdgePartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="mainEdgeQuantity">Quantity</label>
                    <input id="mainEdgeQuantity" type="number" class="form-control" [(ngModel)]="target.mainEdgeQuantity" name="mainEdgeQuantity" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="sideCutPartNumber">GET side cuts &amp; corners part #</label>
                    <input id="sideCutPartNumber" type="text" class="form-control" [(ngModel)]="target.sideCutPartNumber" name="sideCutPartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="sideCutQuantity">Quantity</label>
                    <input id="sideCutQuantity" type="number" class="form-control" [(ngModel)]="target.sideCutQuantity" name="sideCutQuantity" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="boltPinPartNumber">Bolts or pins part #</label>
                    <input id="boltPinPartNumber" type="text" class="form-control" [(ngModel)]="target.boltPinPartNumber" name="boltPinPartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="boltPinQuantity">Quantity</label>
                    <input id="boltPinQuantity" type="number" class="form-control" [(ngModel)]="target.boltPinQuantity" name="boltPinQuantity" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="nutPartNumber">Nut part #</label>
                    <input id="nutPartNumber" type="text" class="form-control" [(ngModel)]="target.nutPartNumber" name="nutPartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="nutQuantity">Quantity</label>
                    <input id="nutQuantity" type="number" class="form-control" [(ngModel)]="target.nutQuantity" name="nutQuantity" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="notes">Notes</label>
            <textarea id="notes" class="form-control" rows="2" [(ngModel)]="target.notes" name="notes"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
